// Process inline math $...$ or $$...$$
// Example: $C_L$ or $$C_L$$ renders as inline math

import type StateInline from '../state-inline'

export default function math_inline(
  state: StateInline,
  silent: boolean,
): boolean {
  const start = state.pos
  const max = state.posMax

  // Check for opening $
  if (state.src.charCodeAt(start) !== 0x24 /* $ */) return false

  // Check if it's $$ or single $
  const isDouble = state.src.charCodeAt(start + 1) === 0x24 /* $ */
  const mathStart = isDouble ? start + 2 : start + 1

  // Inline math must not have whitespace after opening
  if (mathStart < max && state.src.charCodeAt(mathStart) === 0x20) return false

  let pos = mathStart

  // Find closing $ or $$
  let found = false
  while (pos < max) {
    if (state.src.charCodeAt(pos) === 0x24 /* $ */) {
      if (isDouble) {
        // Need closing $$
        if (pos + 1 < max && state.src.charCodeAt(pos + 1) === 0x24 /* $ */) {
          // Inline math must not have whitespace before closing $$
          if (pos > mathStart && state.src.charCodeAt(pos - 1) !== 0x20) {
            found = true
            break
          }
        }
      } else if (pos > mathStart && state.src.charCodeAt(pos - 1) !== 0x20) {
        // Single $ closing — must not have whitespace before closing $
        found = true
        break
      }
    }
    pos++
  }

  if (!found) return false

  const content = state.src.slice(mathStart, pos)

  // Must not be empty and must not contain newlines (inline only)
  if (content.length === 0 || content.includes('\n')) return false

  if (!silent) {
    const token = state.push('math_inline', 'code', 0)
    token.markup = isDouble ? '$$' : '$'
    token.content = content
    token.meta = { type: 'math' }
  }

  state.pos = pos + (isDouble ? 2 : 1)
  return true
}
